import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { FC, useState } from 'react';

type ScheduleMessageModalProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const ScheduleMessageModal: FC<ScheduleMessageModalProps> = ({
  isOpen,
  handleClose,
}) => {
  const [date, setDate] = useState<Dayjs | null>(dayjs().add(30, 'minutes'));

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Schedule Message</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Box>
            <Typography>Date:</Typography>
            <DatePicker
              disablePast
              value={date}
              onChange={(newDate) => setDate(newDate)}
              sx={{ width: '100%' }}
              format="MM/DD/YYYY"
            />
          </Box>
          <Box>
            <Typography>Time:</Typography>
            <TimePicker
              value={date}
              onChange={(newTime) => setDate(newTime)}
              sx={{ width: '100%' }}
            />
          </Box>
          <Button variant="contained" color="secondary">
            Schedule Message
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleMessageModal;
